import {TUser} from 'src/containers/User';

export type TCaptcha = {
  captcha?: string;
  id?: string;
};

export type TSignInPayload = {
  username: string | null;
  password: string | null;
  captchaId: TCaptcha['id'];
  captcha: string | null;
  rememberMe: true;
};

export type TSignInResponse = {
  name?: string;
  login?: string;
  userId?: number;
  description?: string;
  accessExpiresIn?: number;
  refreshExpiresIn?: number;
  tenants: TUser['tenants'];
  otpId?: string;
};

export type TSignInFormData = {
  username: string;
  password: string;
  captcha: string;
};

export type TChangePasswordFormData = {
  oldPassword: string;
  newPassword: string;
  newPasswordRepeat: string;
};

export enum EAuthErrors {
  SEND_WAIT = 'confirmation-send-wait',
  SEND_RETRY = 'confirmation-send-retry',
  SEND_BLOCKED = 'confirmation-send-blocked',
  COMPLETED = 'confirmation-completed',
  TEMPORARY_LOCKED = 'error-temporary-locked',
  INCORRECT_CAPTCHA = 'error-captcha-challenge',
  INCORRECT_CONFIRMATION_CODE = 'confirmation-check-failed',
  OTP_NOT_FOUND = 'otp.not-found',
  OTP_REQUESTS_EXCEEDED = 'otp.too-much-attempts',
}

export type TSendOtpPayload = {
  otpId?: string;
  otpCode: string;
};
